/* ============================================================
   MealPrep.nz - meal picker: honour the answers, show progress

   THE PROBLEM THIS FIXES

   The 5-step plan flow asks goal, who, days and portion size, then
   sends the visitor to /pages/lunch-and-dinner-selection carrying
   ?goal=Lose%20weight&who=Just%20me&days=4%20days&size=Lighter

   The picker ignored all four. Measured: after answering every
   question the active tab was still "All Meals" and all 34 products
   were showing - identical to clicking "See the food" and skipping
   the quiz entirely. Five steps of friction delivering nothing.

   The bundle links had the same fault: ?box=10 arrived and nothing
   read it.

   There was also no running count and no checkout prompt, so once
   someone started adding meals nothing told them how many they had,
   how many were left, or how to finish.

   WHY THIS IS A SEPARATE FILE

   The picker lives in Mealcaresel2.liquid, which is also on the LIVE
   theme and carries a long build history. This attaches from outside
   - it reads the URL, clicks the existing tabs, and appends its own
   progress bar. Nothing in that section is modified, so there is
   nothing to merge or clobber if it changes.

   It no-ops on any page without .filter-tab, so loading it globally
   is safe.
   ============================================================ */
(function () {
  'use strict';

  /* goal answer -> the picker's own data-filter values.
     "Recover from an injury" deliberately maps to all: recovery is
     not a menu range and filtering it to one would hide most of the
     menu from the visitor least able to go hunting for it. */
  var GOAL_TAB = {
    'lose weight': 'keto',
    'build lean muscle': 'lifestyle',
    'just sort dinner': 'lifestyle',
    'feed the household': 'family',
    'recover from an injury': 'all'
  };

  var PEOPLE = { 'just me': 1, 'two of us': 2, 'the family': 4 };

  function qs(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  function targetMeals() {
    var box = parseInt(qs('box'), 10);
    if (box > 0) return box;                       /* bundle link wins */

    var people = PEOPLE[qs('who').toLowerCase()] || 0;
    var days = parseInt(qs('days'), 10) || 0;      /* "4 days" -> 4 */
    if (!people || !days) return 0;

    var n = people * days;
    return Math.min(Math.max(n, 5), 28);
  }

  function applyGoalTab() {
    var goal = qs('goal').toLowerCase().trim();
    if (!goal) return;
    var want = GOAL_TAB[goal];
    if (!want || want === 'all') return;

    /* the page renders two tab strips (inline + sticky); click every
       matching one so they cannot disagree */
    var hit = document.querySelectorAll('.filter-tab[data-filter="' + want + '"]');
    for (var i = 0; i < hit.length; i++) hit[i].click();
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function build(target) {
    var bar = document.createElement('div');
    bar.className = 'mp-pick';
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<div class="mp-pick__in">' +
        '<div class="mp-pick__meter"><i></i></div>' +
        '<div class="mp-pick__txt"><b></b><span></span></div>' +
        '<a class="mp-pick__go" href="/cart"></a>' +
      '</div>';
    document.body.appendChild(bar);
    document.body.classList.add('mp-has-pick');
    return bar;
  }

  function start() {
    if (!document.querySelector('.filter-tab')) return;   /* not the picker */

    applyGoalTab();

    var target = targetMeals();
    if (!target) return;   /* arrived without a plan - leave the page alone */

    var bar = build(target);
    var fill = bar.querySelector('.mp-pick__meter i');
    var big = bar.querySelector('.mp-pick__txt b');
    var sub = bar.querySelector('.mp-pick__txt span');
    var go = bar.querySelector('.mp-pick__go');

    function render(count, total) {
      var left = target - count;
      var pct = Math.min(100, Math.round((count / target) * 100));
      fill.style.width = pct + '%';
      big.textContent = count + ' of ' + target + ' meals';

      if (left > 0) {
        sub.textContent = 'Add ' + left + ' more' + (total ? ' · ' + money(total) : '');
        go.textContent = 'View box';
        bar.classList.remove('is-ready');
      } else {
        sub.textContent = 'Box complete' + (total ? ' · ' + money(total) : '');
        go.textContent = 'Checkout';
        bar.classList.add('is-ready');
      }
    }

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c.item_count || 0, c.total_price || 0); })
        .catch(function () { /* leave the last good state on screen */ });
    }

    refresh();

    /* The picker posts its own add-to-cart, so rather than guess at its
       internals just re-read the cart shortly after any submit inside
       the grid. Cheap, and it cannot break when that section changes. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('form [type="submit"], form button')) {
        setTimeout(refresh, 700);
        setTimeout(refresh, 1800);   /* slower carts */
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
